import { userConstants } from "../../constant";

export function featuredSellers(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_FEATURED_SELLERS:
      return {
        sellers: action.sellers,
      };

    default:
      return state;
  }
}
